<div class="main">
    <ng-content></ng-content>
</div>
<div class="sidebar">
    <ng-content select="vdr-page-detail-sidebar"></ng-content>
</div>
